var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { LookupValueRequest } from "../../../../models/lookups/lookup.models";
import { LookupUtilities } from "../../../../utilities/lookup-utilities";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { LookupAdditionalData } from "../../../../constants/lookups/lookup.constants";
var LookupHierarchyControl = /** @class */ (function () {
    function LookupHierarchyControl(lookupClient, dialogClient) {
        this.lookupClient = lookupClient;
        this.dialogClient = dialogClient;
        this.label = "";
        this.readonly = false;
        this.info = "";
        this.parameters = "";
        this.selectedValuePath = "id";
    }
    Object.defineProperty(LookupHierarchyControl.prototype, "itemSource", {
        get: function () {
            return this._itemSource;
        },
        set: function (x) {
            this._itemSource = x;
            this.rebind();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookupHierarchyControl.prototype, "code", {
        get: function () {
            return this._code;
        },
        set: function (value) {
            if (this._code !== value) {
                this._code = value;
                this.selectedItem = this.searchByCode(this.code, this.itemSource, 0);
                this.selectedValue = this.getValue(this.selectedItem);
            }
        },
        enumerable: false,
        configurable: true
    });
    LookupHierarchyControl.prototype.queryChanged = function (newValue, oldValue) {
        this.loadData();
    };
    LookupHierarchyControl.prototype.selectedItemChanged = function (newValue, oldValue) {
        this._code = newValue ? newValue.additionalData[LookupAdditionalData.code] : this._code;
    };
    LookupHierarchyControl.prototype.bind = function () {
        this.loadData();
    };
    LookupHierarchyControl.prototype.getValue = function (item) {
        return this.selectedValuePath && item ? item[this.selectedValuePath] : item;
    };
    LookupHierarchyControl.prototype.openModal = function () {
        //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK
        if (!window["SystemJS"]) {
            require("" + "./lookup-hierarchy-control-modal");
        }
        this.dialogClient.show(DialogServiceConstants.URLs.LookupHierarchyControlModal, this);
    };
    LookupHierarchyControl.prototype.selectItem = function (lookup) {
        if (lookup.additionalData[LookupAdditionalData.isSelectable]) {
            this.selectedItemInternal = lookup;
        }
    };
    LookupHierarchyControl.prototype.selectedValueChanged = function (newValue, oldValue) {
        if (newValue === oldValue)
            return;
        this.rebind();
    };
    LookupHierarchyControl.prototype.rebind = function () {
        if (this.selectedValue && this.itemSource) {
            this.selectedItem = LookupUtilities.matchLookupByIdRecursively(this.itemSource, Number(this.selectedValue));
            this.selectedItemInternal = this.selectedItem;
        }
    };
    LookupHierarchyControl.prototype.loadData = function () {
        var _this = this;
        var lookupValueRequest = this.createLookupValueRequest();
        this.lookupClient.getLookup(lookupValueRequest)
            .then(function (response) {
            _this.itemSource = response.values;
            _this.rebind();
        }).catch(function () {
        });
    };
    LookupHierarchyControl.prototype.createLookupValueRequest = function () {
        var request = new LookupValueRequest();
        request.lookupValueQuery = this.query;
        request.parameters = this.parameters;
        return request;
    };
    LookupHierarchyControl.prototype.searchByCode = function (code, lookupValues, level) {
        var e_1, _a;
        if (lookupValues) {
            try {
                for (var lookupValues_1 = __values(lookupValues), lookupValues_1_1 = lookupValues_1.next(); !lookupValues_1_1.done; lookupValues_1_1 = lookupValues_1.next()) {
                    var lookupValue = lookupValues_1_1.value;
                    var additionalData = lookupValue.additionalData[LookupAdditionalData.code];
                    var value = (additionalData ? additionalData.toLowerCase() : '') ===
                        code.toLowerCase() &&
                        lookupValue.additionalData[LookupAdditionalData.isSelectable] ? lookupValue : null;
                    if (value) {
                        return value;
                    }
                    else if (lookupValue.children && lookupValue.children.length > 0) {
                        var childrenResult = this.searchByCode(code, lookupValue.children, level + 1);
                        if (childrenResult !== null) {
                            return childrenResult;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (lookupValues_1_1 && !lookupValues_1_1.done && (_a = lookupValues_1.return)) _a.call(lookupValues_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return null;
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupHierarchyControl.prototype, "query", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupHierarchyControl.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupHierarchyControl.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupHierarchyControl.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupHierarchyControl.prototype, "parameters", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], LookupHierarchyControl.prototype, "selectedItem", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], LookupHierarchyControl.prototype, "selectedValue", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupHierarchyControl.prototype, "selectedValuePath", void 0);
    LookupHierarchyControl = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService, DialogClientService])
    ], LookupHierarchyControl);
    return LookupHierarchyControl;
}());
export { LookupHierarchyControl };
